<template>
  <label class="form-label fw-bolder text-dark fs-6 mb-1 me-2">
    {{label}}<span class="required" v-if="this.$attrs.hasOwnProperty('required')"></span>
  </label>
  <slot name="actions"></slot>

  <slot></slot>
  <message-validation v-if="isInvalid" :message="isInvalid"/>
</template>

<script>
import LabelInput from "@forms/LabelInput";
import MessageValidation from "@forms/MessageValidation";

export default {
  components: {
    LabelInput,
    MessageValidation,
  },
  props: {
    label: {
      type: String,
      required: true,
    },

    isInvalid: {
      required: false,
      default: false,
    },
  }
}
</script>
